/** Дата с временем 00:01 — чтобы день не «уплывал» из‑за полуночи/таймзоны */
export function defaultDateTimeAtMinuteOne(date: Date = new Date()): string {
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day} 00:01`
}

// Format date to yyyy.mm.dd
export function formatDate(dateString: string, revers?: boolean) {
  const date = new Date(dateString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Месяцы начинаются с 0
  const year = date.getFullYear()

  if (revers) {
    return `${year}.${month}.${day}`
  }
  return `${day}.${month}.${year}`
}

export function isLessThanAMonth(dateString: string): boolean {
  const targetDate = new Date(dateString)
  const today = new Date()

  const diffInMs = targetDate.getTime() - today.getTime()
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

  return diffInDays < 30
}

export function formatDateAndTime(dateTime: string): string {
  const date = new Date(dateTime)

  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear().toString()

  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')

  return `${day}.${month}.${year} ${hours}:${minutes}`
}

export function getLatestDate(created_at: string, updated_at: string): string {
  const createdDate = new Date(created_at)
  const updatedDate = new Date(updated_at)

  if (updatedDate > createdDate) {
    return updated_at
  } else {
    return created_at
  }
}

export function formatDateToDDMMYYYY(dateString: string) {
  if (!dateString) return ''

  const match = String(dateString).match(/(\d{4})-(\d{2})-(\d{2})/)
  if (match) {
    const [, year, month, day] = match
    return `${day}.${month}.${year}`
  }

  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) return ''

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  return `${day}.${month}.${year}`
}
